import isEqual from 'fast-deep-equal';
import { isPlainObject } from 'lodash';

export const isEmptyObject = (obj: Record<string, any>): boolean => {
  if (!obj || typeof obj !== 'object') return true;
  if (obj instanceof Date) return false;

  return Object.entries(obj).every(([_, value]) => {
    if (value === null || value === undefined) return true;
    if (value instanceof Date) return false;
    if (typeof value === 'object') return isEmptyObject(value);
    return false;
  });
};

export const filterUnchangedValues = <T extends Record<string, any>>(changes: DeepPartial<T>, original?: T): any => {
  if (!original) return changes;

  // Special case: if provider is being changed back to original, remove both provider and location
  if (
    'candidate_event' in changes &&
    'candidate_event' in original &&
    changes.candidate_event &&
    original.candidate_event &&
    'provider' in changes.candidate_event &&
    'provider' in original.candidate_event &&
    changes.candidate_event.provider === original.candidate_event.provider
  ) {
    const { provider, ...rest } = changes.candidate_event;
    const result = { ...changes, candidate_event: rest };
    return isEmptyObject(result) ? {} : result;
  }

  const result = Object.entries(changes).reduce((acc, [key, value]) => {
    const originalValue = original[key];

    if (isPlainObject(value) && isPlainObject(originalValue)) {
      const filteredValue = filterUnchangedValues(value, originalValue);
      if (!isEmptyObject(filteredValue)) {
        acc[key] = filteredValue;
      }
    } else if (!isEqual(value, originalValue)) {
      acc[key] = value;
    }
    return acc;
  }, {});

  return result;
};
